export default "__VITE_ASSET__BvZoNUY9__"